import z from 'zod';

import { LocationData } from '../LocationsContainer/types';

export const StatusIndicator = ({ location }: { location: LocationData }) => {
  const getStatus = (location: LocationData) => {
    if (location.status === 'Active') {
      return { text: 'Active', color: 'var(--color-green)' };
    } else {
      return { text: 'Inactive', color: 'var(--color-orange)' };
    }
  };

  const status = getStatus(location);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{status?.text}</span>
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: status?.color
        }}
      />
    </div>
  );
};

export const passwordSchema = z
  .string()
  .trim()
  .min(8, 'Password must be at least 8 characters long')
  .regex(/[A-Z]/, 'Password must include at least one uppercase letter')
  .regex(/[a-z]/, 'Password must include at least one lowercase letter')
  .regex(/[0-9]/, 'Password must include at least one number')
  .regex(
    /[!@#$%^&*(),.?":{}|<>]/,
    'Password must include at least one special character (e.g., !, @, #, $, %)'
  );

export const baseSchema = z.object({
  username: z.string().min(1, 'The username is required'),
  name: z.string().min(1, 'The name is required'),
  email: z.string().trim().email('Invalid email address'),
  company: z.string().min(1, 'The company is required'),
  companyId: z.number().optional(),
  password: passwordSchema
});

export const createUserSchema = baseSchema.superRefine((data, ctx) => {
  if (data.company && !data.companyId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Please select a company from the list',
      path: ['company']
    });
  }
});

export const updateUserSchema = baseSchema
  .omit({ password: true })
  .superRefine((data, ctx) => {
    if (data.company && !data.companyId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please select a company from the list',
        path: ['company']
      });
    }
  });

export const parseUserSchema = (parsedData: any) => {
  const errors: { [k: string]: string } = {};
  parsedData.error.errors.forEach(
    (e: { path: { toString: () => string | number }[]; message: string }) => {
      if (e.path[0]) errors[e.path[0].toString()] = e.message;
    }
  );
  return errors;
};
